import { api } from "./api";

const basePath = "/status";

export const statusService = {
  list(params) {
    return api.get(`${basePath}/`, { params });
  },

  getById(id) {
    return api.get(`${basePath}/${id}/`);
  },

  create(payload) {
    return api.post(`${basePath}/`, payload);
  },

  update(id, payload) {
    return api.patch(`${basePath}/${id}/`, payload);
  },

  remove(id) {
    return api.delete(`${basePath}/${id}/`);
  },

  listActive() {
    return api.get(`${basePath}/`, { params: { is_active: true } });
  },
};

export default statusService;
